import { render, staticRenderFns } from "./LoadingAppOverlay.vue?vue&type=template&id=af8c4a9e"
import script from "./LoadingAppOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingAppOverlay.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports